'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isAlwaysAvailable;
function isAlwaysAvailable(iterator) {
    if (!iterator.hasNext()) return false;

    var next = iterator.next();
    return next.status === 'available' && !next.until;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/availability/dist/utils/IsAlwaysAvailable.js
// module id = 879
// module chunks = 0